import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import ScrollBar from "react-perfect-scrollbar";
import { Button, Card, Dropdown } from "react-bootstrap";
import NumberFormat from "react-number-format";
import ApexCharts from "apexcharts";

//
import {
  portfolioTypeFilters,
  portfolioChartTimeFilters,
} from "../../constances";

//
import FilterBox from "../general/FilterBox";
import BoxLoading from "../general/BoxLoading";
import BalanceChart from "./BalanceChart";
import StatisticsInfo from "./StatisticsInfo";
import DesktopAssetsList from "./DesktopAssetsList";
import MobileAssetsList from "./MobileAssetsList";
import ImageBox from "../general/ImageBox";

import CreateAssetModal from "./CreateAssetModal";
import EditPortfolioModal from "./EditPortfolioModal";
import EditTransactionModal from "./EditTransactionModal";

//
import pointImage from "../../assets/img/point.png";

//
import {
  deletePortfolio,
  getPortfolioDetail,
  getPortfolioChart,
  deleteTransaction,
  deleteAsset,
} from "../../redux/features/portfolio/actions";

//
import { setPortfolioDetail } from "../../redux/features/portfolio/slice";
import { iconImage } from "../../redux/features/coins/actions";

//
import AssetInfo from "./AssetInfo";
import DesktopTransactionList from "./DesktopTransactionList";
import MobileTransactionList from "./MobileTransactionList";
import Allocation from "./Allocation";

const fakePortfolioDetail = {
  balance: 0,
  assets: [],
  allocation: null,
  statistic: {
    best: null,
    total: null,
    worst: null,
  },
};

function BalanceChartBox({
  windowSize,
  activePortfolio,
  deletePortfolio,
  portfolioDetail,
  setPortfolioDetail,
}) {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);

  //
  const [chart, setChart] = useState({ values: [], dates: [] });

  //
  const [showCreateAsset, setShowCreateAsset] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showEditTransactionModal, setShowEditTransactionModal] =
    useState(false);

  //
  const [assetInfo, setAssetInfo] = useState({});
  const [transactionInfo, setTransactionInfo] = useState({});

  //
  const [type, setType] = useState({
    type: "chart",
    name: "Chart",
  });

  const [time, setTime] = useState({
    type: "all",
    name: "All",
  });

  const updateChartTimeFrame = (item) => {
    let newTime = { ...time };
    newTime.type = item.type;
    newTime.name = item.name;
    setTime(newTime);

    let start = null;
    let end = new Date(chart.dates[chart.dates.length - 1]).getTime();

    if (item.type === "24H") {
      start = new Date(
        chart.dates[chart.dates.length > 1 ? chart.dates.length - 2 : 0]
      ).getTime();
    }

    if (item.type === "7D") {
      start = new Date(
        chart.dates[chart.dates.length > 7 ? chart.dates.length - 8 : 0]
      ).getTime();
    }

    if (item.type === "30D") {
      start = new Date(
        chart.dates[chart.dates.length > 30 ? chart.dates.length - 31 : 0]
      ).getTime();
    }

    if (item.type === "90D") {
      start = new Date(
        chart.dates[chart.dates.length > 90 ? chart.dates.length - 91 : 0]
      ).getTime();
    }

    if (item.type === "all") {
      start = new Date(chart.dates[0]).getTime();
    }

    ApexCharts.exec("area-datetime", "zoomX", start, end);
  };

  /**
   * Delete Portfolio
   */
  const delete_portfolio = async () => {
    // start loading
    setLoading(true);

    // set variable
    let id = activePortfolio?.info?.id;

    // request
    await deletePortfolio(id);

    // stop loading
    setLoading(false);
  };

  /**
   * Delete Transaction
   */
  const delete_transaction = async (id) => {
    // start loading
    setLoading(true);

    // request
    await deleteTransaction(id).then((res) => {
      if (res) {
        updateTransactions(res);
      }
    });

    // stop loading
    setLoading(false);
  };

  const updateTransactions = (asset) => {
    if (Array.isArray(asset)) {
      setStep(1);
    } else {
      let info = {};
      let assets = asset.assets;
      for (let i = 0; i < assets.length; i++) {
        const element = assets[i];
        if (element.coin_id === assetInfo.coin_id) {
          info = element;
        }
      }
      if (info.coin_id) {
        setAssetInfo(info);
      } else {
        setStep(1);
      }
    }
    updateAssest(asset);
  };

  /**
   * Delete Asset
   */
  const delete_asset = async (symbol, portfolio_id) => {
    // start loading
    setLoading(true);

    let content = {
      symbol,
    };

    // request
    await deleteAsset({ content, portfolio_id }).then((res) => {
      if (res) {
        updateAssest(res);
      }
    });

    // stop loading
    setLoading(false);
  };

  /**
   * Open Update Asset Modal
   */
  const showAssetTransactions = (content) => {
    console.log(content);
    setAssetInfo(content);
    setStep(2);
  };

  /**
   * Open Edit Transactions Modal
   */
  const showEditTransactions = (content) => {
    setTransactionInfo(content);
    setShowEditTransactionModal(true);
  };

  /**
   * Get Portfolio Detail
   * if response is ok , change active
   */
  const get_portfolio_detail = async () => {
    if (activePortfolio?.info?.id) {
      // start loading
      setLoading(true);

      // set variable
      let id = activePortfolio.info.id;

      // request
      await getPortfolioDetail(id).then((res) => {
        if (res) {
          updateAssest(res);
        }
      });

      // stop loading
      setLoading(false);
    } else {
      updateAssest([]);
      let balanceChart = { ...chart };
      balanceChart.values = [];
      balanceChart.dates = [];
      console.log(balanceChart);
      setChart(balanceChart);
    }
  };

  /**
   * Refresh Data after asset add - delete - update
   */
  const updateAssest = (data) => {
    let { assets, allocation, statistic, balance } = Array.isArray(data)
      ? fakePortfolioDetail
      : data;

    setPortfolioDetail({ assets, allocation, statistic, balance });

    get_portfolio_chart();
  };

  /**
   * Get Portfolio Chart
   */
  const get_portfolio_chart = async () => {
    if (activePortfolio?.info?.id) {
      // start loading
      setLoading(true);

      // set variable
      let id = activePortfolio.info.id;

      // request
      await getPortfolioChart(id).then((res) => {
        if (res) {
          let chartData = { ...chart };
          chartData.values = res.values;
          chartData.dates = res.dates;
          setChart(chartData);
        }
      });

      // stop loading
      setLoading(false);
    }
  };

  useEffect(() => {
    setStep(1);
    get_portfolio_detail();

    // eslint-disable-next-line
  }, [activePortfolio?.info?.id]);

  return (
    <>
      <Card.Header className="no-border">
        {step === 1 ? (
          <div className="holder">
            <div className="img-name">
              <img src={pointImage} alt="icon" />
              <div className="current-balance">
                <div>
                  <small>Current Balance</small>
                  <h4>
                    <NumberFormat
                      key={activePortfolio?.balances?.USDT}
                      value={activePortfolio?.balances?.USDT}
                      decimalScale='2'
                      displayType={"text"}
                      prefix="$"
                      thousandSeparator={true}
                      decimalSeparator="."
                    />
                  </h4>
                  <h4>
                    <NumberFormat
                      key={activePortfolio?.balances?.BTC}
                      value={activePortfolio?.balances?.BTC}
                      decimalScale='8'
                      displayType={"text"}
                      prefix="₿"
                      thousandSeparator={true}
                      decimalSeparator="."
                    />
                  </h4>
                </div>

                {activePortfolio?.info?.id && (
                  <Dropdown align="end" className="edit-dropdown">
                    <Dropdown.Toggle className="no-border">
                      <i className="las la-ellipsis-v"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <ScrollBar>
                        <Dropdown.Item onClick={() => delete_portfolio()}>
                          <small className="text-danger d-flex align-items-center fw-bolder">
                            <i className="las la-trash text-danger"></i>
                            Delete
                          </small>
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setShowEditModal(true)}>
                          <small className="text-black d-flex align-items-center fw-bolder">
                            <i className="las la-edit"></i>
                            Edit
                          </small>
                        </Dropdown.Item>
                      </ScrollBar>
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
            {activePortfolio?.info?.id && (
              <Button
                variant="info"
                className="modal-btn"
                onClick={() => setShowCreateAsset(true)}
              >
                Add New
              </Button>
            )}
          </div>
        ) : (
          <>
            <Button
              variant="secondary"
              className="with-icon back-btn"
              onClick={() => setStep(1)}
            >
              <i className="las la-angle-left"></i>
              Back
            </Button>
            <div className="holder">
              <div className="img-name">
                {/* <div>
                  <ImageBox src={iconImage(assetInfo.symbol)} />
                </div> */}
                <div className="current-balance px-0">
                  <div>
                    <small>{assetInfo.symbol}</small>
                    <h4>
                      <NumberFormat
                        value={+assetInfo?.holding?.USDT}
                        displayType={"text"}
                        prefix="$"
                        decimalScale="2"
                        thousandSeparator={true}
                        decimalSeparator="."
                      />
                    </h4>
                    <h4>
                      <NumberFormat
                        value={+assetInfo?.holding?.BTC}
                        displayType={"text"}
                        prefix="₿"
                        decimalScale="8"
                        thousandSeparator={true}
                        decimalSeparator="."
                      />
                    </h4>
                  </div>

                  <Dropdown align="end" className="edit-dropdown">
                    <Dropdown.Toggle className="no-border">
                      <i className="las la-ellipsis-v"></i>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <ScrollBar>
                        <Dropdown.Item
                          onClick={() =>
                            delete_asset(assetInfo.coin_id, activePortfolio.info.id)
                          }
                        >
                          <small className="text-danger d-flex align-items-center fw-bolder">
                            <i className="las la-trash text-danger"></i>
                            Delete asset
                          </small>
                        </Dropdown.Item>
                      </ScrollBar>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          </>
        )}
      </Card.Header>
      <Card.Body>
        {step === 1 ? (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <FilterBox
                filters={portfolioTypeFilters}
                setFilter={(item) => setType(item)}
                active={type}
              />

              {type.type === "chart" && windowSize >= 576 && (
                <FilterBox
                  filters={portfolioChartTimeFilters}
                  setFilter={(item) => updateChartTimeFrame(item)}
                  active={time}
                />
              )}
            </div>
            {type.type === "chart" && <BalanceChart data={chart} />}

            {type.type === "allocation" && (
              <Allocation data={portfolioDetail.allocation} />
            )}

            {type.type === "statistic" && (
              <StatisticsInfo data={portfolioDetail.statistic} />
            )}

            {type.type === "chart" && windowSize < 576 && (
              <div className="d-flex align-items-center justify-content-between">
                <FilterBox
                  filters={portfolioChartTimeFilters}
                  setFilter={(item) => updateChartTimeFrame(item)}
                  active={time}
                />
              </div>
            )}

            <div className="space d-block d-sm-none"></div>
            <p className="title fw-bolder text-black">Your Assets</p>
            {windowSize > 576 ? (
              <DesktopAssetsList
                items={portfolioDetail.assets}
                delete_asset={(coin_id, portfolio_id) =>
                  delete_asset(coin_id, portfolio_id)
                }
                showAssetTransactions={(content) =>
                  showAssetTransactions(content)
                }
              />
            ) : (
              <MobileAssetsList
                items={portfolioDetail.assets}
                delete_asset={(coin_id, portfolio_id) =>
                  delete_asset(coin_id, portfolio_id)
                }
                showAssetTransactions={(content) =>
                  showAssetTransactions(content)
                }
              />
            )}
          </>
        ) : (
          <>
            <AssetInfo
              symbol={assetInfo.symbol}
              quantity={assetInfo.quantity}
              avgPrice={assetInfo.avgPrice}
              benefit={assetInfo.benefit}
              benefitPercent={assetInfo.benefitPercent}
            />

            <div className="space d-block d-sm-none"></div>
            <p className="title fw-bolder text-black">Asset Transactions</p>
            {windowSize > 576 ? (
              <DesktopTransactionList
                symbol={assetInfo.symbol}
                items={assetInfo.transactions}
                delete_transaction={(id) => delete_transaction(id)}
                showEditTransactions={(content) =>
                  showEditTransactions(content)
                }
              />
            ) : (
              <>
                <MobileTransactionList
                  symbol={assetInfo.symbol}
                  items={assetInfo.transactions}
                  delete_transaction={(id) => delete_transaction(id)}
                  showEditTransactions={(content) =>
                    showEditTransactions(content)
                  }
                />
              </>
            )}
          </>
        )}
      </Card.Body>

      <EditPortfolioModal
        show={showEditModal}
        setShow={(status) => setShowEditModal(status)}
      />

      <CreateAssetModal
        show={showCreateAsset}
        setShow={(status) => setShowCreateAsset(status)}
        active={activePortfolio}
        updateAssest={(data) => updateAssest(data)}
      />

      <EditTransactionModal
        show={showEditTransactionModal}
        setShow={(status) => setShowEditTransactionModal(status)}
        info={transactionInfo}
        updateTransactions={(asset) => updateTransactions(asset)}
      />

      {loading && <BoxLoading />}
    </>
  );
}

BalanceChartBox.propTypes = {
  windowSize: PropTypes.number.isRequired,
  activePortfolio: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  deletePortfolio,
  setPortfolioDetail,
};

const mapStateToProps = (state) => ({
  windowSize: state.themeReducer.windowSize,
  portfolios: state.portfolioReducer.portfolios,
  activePortfolio: state.portfolioReducer.activePortfolio,
  portfolioDetail: state.portfolioReducer.portfolioDetail,
});

export default connect(mapStateToProps, mapDispatchToProps)(BalanceChartBox);
